// One server-gated entry for saved record questions and general writing.
import { useI18n } from '@affine/i18n';
import { AiIcon } from '@blocksuite/icons/rc';
import { useServices } from '@toeverything/infra';

import { MenuLinkItem } from '../../modules/app-sidebar/views';
import { useErpProvisioning } from '../../modules/erp';
import { WorkbenchService } from '../../modules/workbench';
import { useNavPrefixActive } from './use-nav-prefix-active';

export const AskButton = () => {
  const t = useI18n();
  const provisioning = useErpProvisioning();
  const { workbenchService } = useServices({ WorkbenchService });
  const workbench = workbenchService.workbench;
  // REACTIVE active state: the /ask route keeps the entry lit.
  const active = useNavPrefixActive(workbench, '/ask');

  // The gate: hidden unless the central AI policy allows the actor (fail-closed on null).
  if (!provisioning?.canUseAiAgents) {
    return null;
  }

  return (
    <MenuLinkItem icon={<AiIcon />} active={active} to={'/ask'}>
      <span data-testid="pipe-ask-nav">{t['com.affine.pipe.ask.nav']()}</span>
    </MenuLinkItem>
  );
};
